import _ from 'lodash'
import * as PIXI from 'pixi.js'
import Ticker from '../utils/ticker.js'
import Raf from 'quark-raf'

class SpriteHandler {

	// Settings
	transparent = false
	autoResize = true
	antialias = false
	size = {w: 1440,h:900}
	ticker = new Ticker()
	loaded = false

	constructor (params) {
				
		Object.assign(this,params)

		this._animate = this._animate.bind(this)

		this._initStage()
		this._initLoader()

		return this
	}


	_initStage () {

		// PIXI Renderer
		this.renderer = PIXI.autoDetectRenderer(this.size.w, this.size.h, {
			antialias: this.antialias,
			transparent: this.transparent,
			resolution: window.devicePixelRatio,
			autoResize: this.autoResize
		})

		// PIXI Stage
		this.stage = new PIXI.Container()
		this.dom.appendChild(this.renderer.view)
	}


	_initLoader () {

		this.loader = new PIXI.loaders.Loader()
		this.loader.reset()
		this.loader.add(this.url)
		this.loader.load(this._spriteLoaded.bind(this))
	
	}

	_spriteLoaded () {

		let frames = [], i = 0, l = this.frame.amount

		for (i ; i < l; i++) {
			const f = PIXI.Texture.fromFrame(this.frame.baseName + i + this.frame.extension)
			frames.push(f)
		}

		this.anim = new PIXI.extras.AnimatedSprite(frames)
		this.stage.addChild(this.anim)
		Raf.add(this._animate)
		// this.ticker.tick(`sprite_${this.name}`,this._animate.bind(this))
		
		this.loaded = true
	}


	_animate () {
		this.renderer.render(this.stage)
	}

	play () {
		this.ticker.play(`sprite_${this.name}`)
	}

	pause () {
		this.ticker.pause(`sprite_${this.name}`)
	}

}


export default SpriteHandler


// WEBPACK FOOTER //
// ./src/utils/spriteHandler.js